<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Gift
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="gift Category"
                outlined
                v-model="form.gift_category_id"
                :items="giftCategoryItems"
                label="Gift Category"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.gift_category_id"
              ></v-autocomplete>
            </v-col>
            <!-- <v-col sm="4">
              <v-autocomplete
                ref="store"
                outlined
                v-model="form.store_id"
                :items="storeItems"
                label="Store"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.store_id"
              ></v-autocomplete>
            </v-col> -->
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.quantity"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Gift
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "GiftCreatePage",
  data() {
    return {
      form: {
        gift_category_id: "",
        quantity: 0,
        name: "",
      },
      isLoading: false,
      giftCategoryItems: [],
      storeItems: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`gifts/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.gift_categories.forEach((giftCategory) => {
            this.giftCategoryItems.push({
              id: giftCategory.id,
              text: giftCategory.name,
              value: giftCategory.id,
            });
          });
          //Stores
          masters.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.name,
              value: store.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/gifts", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/gifts");
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
